import React, { Component } from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";

import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

// pages
import Login from "./pages/Login";
import Players from "./pages/Players";
import Welcome from "./pages/Welcome";
import Votes from "./pages/Votes";
import VotesClosed from "./pages/VotesClosed";
import Error from "./pages/Error";
import { Privacy } from "./pages/Privacy";

import AuthService from "./services/auth";
import Analytics from "./components/Analytics";
import Button from "./components/Button";
import LoadingMask from "./components/LoadingMask";
import { DATE_VOTE_FINISHED } from "./util/constants";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userData: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    AuthService.validateToken()
      .then((res) => {
        if (window.location.pathname === "/") {
          window.location.replace("/welcome");
        }

        this.getUserData();
      })
      .catch((err) => {
        if (window.location.pathname !== "/") {
          window.location.replace("/");
        }

        this.setState({
          isLoading: false,
        });
      });
  }

  getUserData = () => {
    AuthService.getCurrentUserData().then((response) => {
      this.setState({
        userData: response.data.data,
        isLoading: false,
      });
    });
  };

  onLogout = () => {
    AuthService.logout();
    window.location.replace("/");
  };

  render() {
    const { userData, isLoading } = this.state;
    const now = new Date();
    const nowDate = new Date(now.getTime());
    const voteEndDate = new Date(new Date(DATE_VOTE_FINISHED).getTime());

    return (
      <div className="AppContainer">
        {isLoading && <LoadingMask />}

        <div className="Header">
          {userData && (
            <>
              <Button
                className="Header_privacy"
                onClick={() => {
                  window.location.replace("/privacy");
                }}
              >
                política de privacidade
              </Button>
              <div className="Header__user">
                {" "}
                <span className="Header__username">
                  Olá, <b>{userData.displayName}</b>
                </span>
                <Button
                  onClick={this.onLogout}
                  text="Sair"
                  className="Header__user-btn"
                />
              </div>
            </>
          )}
          {nowDate <= voteEndDate && (
            <>
              {!userData && (
                <>
                  <div className="Header__user">
                    {" "}
                    <span className="Header__username">
                      Olá,{" "}
                      <a href="/login">
                        <b>faça login</b>
                      </a>{" "}
                      para continuar
                    </span>
                  </div>
                </>
              )}
            </>
          )}
        </div>

        <ToastContainer />

        <Router>
          <Analytics>
            <Switch>
              <Route path="/players" component={Players} />
              <Route path="/welcome" component={Welcome} />
              <Route path="/votes" component={Votes} />
              <Route path="/votes-closed" component={VotesClosed} />
              <Route path="/error" component={Error} />
              <Route path="/privacy" component={Privacy} />
              <Route path="/" component={Login} />
            </Switch>
          </Analytics>
        </Router>
      </div>
    );
  }
}

export default App;
